// import React from 'react';
import React, { useState} from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "react-js-loader";
import { Modal, Button } from "react-bootstrap";
import CryptoJS from 'crypto-js';

export const CheckProductDetail = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log(searchParams);
    const nav = useNavigate();
    let programDetail = JSON.parse(localStorage.getItem('programDetail')) ? JSON.parse(localStorage.getItem('programDetail')) : 0;

    if (programDetail == '0' && window.location.pathname != "/program-list") {
        return nav('/program-list');
    }
    return true;
}

export const CustomLoader = () => {
  return (
      <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
          zIndex: 9999 // Ensure it's above all other content
      }}>
          <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
          }}>
              <Loader type="spinner-default" bgColor={"#000"} color={'#FFFFFF'} size={100} />
          </div>
      </div>
  )
}
export const NORECORDS = ({marginTop="40%",message='No Records'}) => {
    return (
      <div style={{marginTop: marginTop,textAlign: "center"}}>{message}</div>
    )

}

export const decruptCipher = (ciphertext) => {

  var key = 'a1b2c3d4e5f6g7h8';
  var ciphertextWA = CryptoJS.enc.Base64.parse(ciphertext);
  var keyWA = CryptoJS.enc.Utf8.parse(key);
  var ivWA = CryptoJS.lib.WordArray.create(ciphertextWA.words.slice(0, 4));
  var hmacWA = CryptoJS.lib.WordArray.create(ciphertextWA.words.slice(4, 4 + 8));
  var actualCiphertextWA = CryptoJS.lib.WordArray.create(ciphertextWA.words.slice(4 + 8));
  var hmacCalculatedWA = CryptoJS.HmacSHA256(actualCiphertextWA, keyWA);
  var decryptedMessageWA = CryptoJS.AES.decrypt({ ciphertext: actualCiphertextWA }, keyWA, { iv: ivWA });
  var decryptedMessage = CryptoJS.enc.Utf8.stringify(decryptedMessageWA);
  
  return JSON.parse(decryptedMessage);
}

export const decruptCipherComapny = (ciphertext) => {

  var key = 'a1b2c3d4e5f6g7h8';
  
  var ciphertextWA = CryptoJS.enc.Base64.parse(ciphertext);
  console.log('ciphertextWA=='+ciphertextWA)
  var keyWA = CryptoJS.enc.Utf8.parse(key);
  var ivWA = CryptoJS.lib.WordArray.create(ciphertextWA.words.slice(0, 4));
  var hmacWA = CryptoJS.lib.WordArray.create(ciphertextWA.words.slice(4, 4 + 8));
  var actualCiphertextWA = CryptoJS.lib.WordArray.create(ciphertextWA.words.slice(4 + 8));
  var hmacCalculatedWA = CryptoJS.HmacSHA256(actualCiphertextWA, keyWA);
  var decryptedMessageWA = CryptoJS.AES.decrypt({ ciphertext: actualCiphertextWA }, keyWA, { iv: ivWA });
  var decryptedMessage = CryptoJS.enc.Utf8.stringify(decryptedMessageWA);
  
  // return JSON.parse(decryptedMessage);
}

export const CustomLoading = () => {
  return (
      <>
        <div style={{float: "right"}}>
          <div className="spinner-grow text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <div className="spinner-grow text-secondary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <div className="spinner-grow text-success" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <div className="spinner-grow text-danger" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </>
  )

}



export const FormErrors = ({formErrors}) =>{ 
  <div className='formErrors'>
    {Object.keys(formErrors).map((fieldName, i) => {
      if(formErrors[fieldName].length > 0){
        return (
          <p key={i}>{fieldName} {formErrors[fieldName]}</p>
        )        
      } else {
        return '';
      }
    })}
  </div>
}

export const ModalBox = (props) =>{ 
  
  const showModal= props.showModaln;
  const modalbodyComponent = props.bodyn;
  const title = props.titlen ;
  const type = props.type ;
  // alert(type)
  let cls = '';
  if(type==''  || typeof(type)=='undefined'){
    cls = (title=='Alert') ?'modal-sm': ((title=='Alert!') ? 'modal-md' : 'modal-xl');
  }else{
    cls = (type=='sm') ?'modal-sm': ((type=='md') ? 'modal-md' : 'modal-xl');
  }
  // console.log(type,title, cls);
  return (
      <>
        <Modal dialogClassName={cls} show={showModal} onHide={props.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title style={{width: "100%",textAlign: "center",fontWeight : "700"}}>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body >
            {modalbodyComponent}
          </Modal.Body>
          {/* <Modal.Footer>
            <Button variant="secondary" onClick={props.handleClose}>
              Close
            </Button>
          </Modal.Footer> */}
        </Modal>
      </>
  );
  
}

export function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

export const checkUserAccess = () => {
  
  let accessFrom= localStorage.getItem('access');
  if (accessFrom=='superadmin') {
    return '/home';      
  }else if (accessFrom=='admin') {
    return '/home';      
  }else if (accessFrom=='operator') {
    return '/history';      
  }else{
      return '/history';
  }
  return true;
}
export const TruncateString = (props) => {
  
  const { str, N, onReadMoreClick } = props;
  const truncatedString = str.length > N ? str.substring(0, N) + '...' : str;

  const handleReadMoreClick = () => {
    console.log(props.counter);
    if (onReadMoreClick) {
      props.onReadMoreClick(props.counter);
    }
  };

  return (
    <div>
      <p>
        {truncatedString}
        {str.length > N && <a href="javascript:void(0);" onClick={handleReadMoreClick}>Read More</a>}
      </p>
    </div>
  );
};

export function DisplayStarRating({ value }) {
  const fullStars = Math.floor(value);
  const remainingDecimal = value - fullStars;
  var fillPercentage = remainingDecimal > 0 ? remainingDecimal * 100 : 0;
  if(fullStars == 4){
    fillPercentage = fillPercentage / 6;
  }else if(fullStars == 3){
    fillPercentage = fillPercentage / 5;
  }else if(fullStars == 2){
    fillPercentage = fillPercentage / 4;
  }else if(fullStars == 1){
    fillPercentage = fillPercentage / 2;
  }
 

  const renderStars = () => {
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={i} className="star full">&#9733;</span>);
    }

    if (fillPercentage > 0) {
      stars.push(
        <span key={fullStars} className="star" style={{ width: `${fillPercentage}%` }}>
          &#9733;
        </span>
      );
    }

    return stars;
  };

  return <div className="star-rating">{renderStars()}</div>;
};
  



  export function formatDate_dMYHiP(inputDate) {
    if(inputDate=='-' || inputDate==''){
      return inputDate;
    }

    const date = new Date(inputDate);
  
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    // Convert to 12-hour format
    hours = hours % 12 || 12;
  
    const formattedDate = `${day} ${month} ${year} ${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    return formattedDate; // Output: "23 Aug 2023 02:30 PM"
  }
  
export const downloadExcel = (fields = [], data = [],fileName='excel') => {
  if (!fields.length || !data.length) return;

  // Create the header row from the field `name`
  const headerRow = fields.map(field => field.name).join(',');

  // Map each data row using the field `key`
  const dataRows = data.map(row =>
    fields.map(field => `"${row[field.key] ?? ''}"`).join(',')
  );

  // Combine all rows
  const csvContent = [headerRow, ...dataRows].join('\n');

  // Create and download the CSV file
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
